import React from 'react';
import './App.css';
import UltimateTicTacToeGame from './components/UltimateTicTacToeGame';

const App: React.FC = () => {
  return (
    <div className="App">
      <UltimateTicTacToeGame />
    </div>
  );
};

export default App;